import { usePageTitle } from '@btime/react-hooks'
import React from 'react'

import { usePermalinkNavigation } from '../../../../utils/routes/permalinkNavigation'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import { TITLES } from '../documents'
import PageHeaderPanel from '../../../../components/presentation/PageHeaderPanel'
import TemplateRecordPdfPrintButton from '../../../../containers/templateRecords/TemplateRecordPdfPrintButton'

const PageHeader = ({ templateId, variant }) => {
  const title = TITLES[variant]
  const serviceOrder = useServiceOrder()
  const navigate = usePermalinkNavigation()
  usePageTitle(title)

  return (
    <PageHeaderPanel
      leftIcon="BsArrowLeftShort"
      leftAction={() => navigate(`/service-orders/${serviceOrder.id}/resume`)}
      title={title}
      mediumPadding
      noContainer
      side={<TemplateRecordPdfPrintButton name={title} recordId={serviceOrder.id} templateId={templateId} />}
    />
  )
}

export default PageHeader
